'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeLocation = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _toArray2 = require('babel-runtime/helpers/toArray');

var _toArray3 = _interopRequireDefault(_toArray2);

exports.doBuildNewPath = doBuildNewPath;
exports.doRedirectPricingPages = doRedirectPricingPages;
exports.doRedirectGenericPages = doRedirectGenericPages;
exports.doChangeLocation = doChangeLocation;
exports.loadSaga = loadSaga;
exports.watchSaga = watchSaga;

var _sagaTools = require('@classpass/saga-tools');

var _dal = require('@classpass/dal');

var _reactRouterRedux = require('react-router-redux');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _helpers = require('redux/saga/helpers');

var _location = require('redux/saga/helpers/location');

var _msas = require('redux/saga/helpers/msas');

var _request = require('redux/saga/selectors/request');

var _msas2 = require('redux/saga/selectors/msas');

var _Banners = require('features/Banners/Banners.reducer');

var _promotions = require('constants/promotions');

var _location2 = require('containers/LocationModal/location.saga');

var _homepage = require('redux/modules/features/homepage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doBuildNewPath),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doRedirectPricingPages),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doRedirectGenericPages),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(doChangeLocation),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(loadSaga),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(watchSaga);

var changeLocation = exports.changeLocation = function changeLocation(lat, lon) {
  return {
    type: 'CHANGE_LOCATION', lat: lat, lon: lon
  };
};

function doBuildNewPath(client, _ref) {
  var path = _ref.path,
      msaList = _ref.msaList,
      newMsaId = _ref.newMsaId;

  var oldMsa, newMsa, newPath, _path$split, _path$split2, nil, page, rest;

  return _regenerator2.default.wrap(function doBuildNewPath$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_msas.getMsaFromPath, client, path);

        case 2:
          oldMsa = _context.sent;
          newMsa = (0, _msas2.msaById)(msaList, newMsaId);
          newPath = void 0;

          if (oldMsa) {
            newPath = path.replace(oldMsa.alias, newMsa.alias);
          } else {
            _path$split = path.split('/'), _path$split2 = (0, _toArray3.default)(_path$split), nil = _path$split2[0], page = _path$split2[1], rest = _path$split2.slice(2);

            newPath = [nil, page, newMsa.alias].concat((0, _toConsumableArray3.default)(rest)).join('/');
          }
          return _context.abrupt('return', newPath);

        case 7:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function doRedirectPricingPages(client, _ref2) {
  var path = _ref2.path,
      msaList = _ref2.msaList,
      newMsaId = _ref2.newMsaId;
  var newPath, newCmsData;
  return _regenerator2.default.wrap(function doRedirectPricingPages$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (newMsaId) {
            _context2.next = 4;
            break;
          }

          _context2.next = 3;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/'));

        case 3:
          return _context2.abrupt('return');

        case 4:
          _context2.next = 6;
          return (0, _effects.call)(doBuildNewPath, client, { path: path, msaList: msaList, newMsaId: newMsaId });

        case 6:
          newPath = _context2.sent;
          _context2.prev = 7;
          _context2.next = 10;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.cms, [client, newPath]);

        case 10:
          newCmsData = _context2.sent;

          if (!newCmsData) {
            _context2.next = 14;
            break;
          }

          _context2.next = 14;
          return (0, _effects.put)((0, _reactRouterRedux.replace)(newPath));

        case 14:
          _context2.next = 25;
          break;

        case 16:
          _context2.prev = 16;
          _context2.t0 = _context2['catch'](7);

          if (!(_context2.t0 instanceof _dal.DALNotFoundError)) {
            _context2.next = 24;
            break;
          }

          _context2.next = 21;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/pricing/' + _promotions.GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS));

        case 21:
          _context2.next = 23;
          return (0, _effects.put)((0, _Banners.addGenericNotification)('Uh oh! That promotion isn’t valid in your city. Choose a plan below to get started.', {
            timeout: 0
          }));

        case 23:
          return _context2.abrupt('return');

        case 24:
          throw _context2.t0;

        case 25:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[7, 16]]);
}

function doRedirectGenericPages(client, _ref3) {
  var path = _ref3.path,
      msaList = _ref3.msaList,
      newMsaId = _ref3.newMsaId;
  var newPath, newCmsData;
  return _regenerator2.default.wrap(function doRedirectGenericPages$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.call)(doBuildNewPath, client, { path: path, msaList: msaList, newMsaId: newMsaId });

        case 2:
          newPath = _context3.sent;
          _context3.prev = 3;
          _context3.next = 6;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.cms, [client, newPath]);

        case 6:
          newCmsData = _context3.sent;

          if (!newCmsData) {
            _context3.next = 10;
            break;
          }

          _context3.next = 10;
          return (0, _effects.put)((0, _reactRouterRedux.replace)(newPath));

        case 10:
          _context3.next = 19;
          break;

        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3['catch'](3);

          if (!(_context3.t0 instanceof _dal.DALNotFoundError)) {
            _context3.next = 18;
            break;
          }

          _context3.next = 17;
          return (0, _effects.put)((0, _Banners.addGenericNotification)('Please provide a valid location.', {
            timeout: 0
          }));

        case 17:
          return _context3.abrupt('return');

        case 18:
          throw _context3.t0;

        case 19:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[3, 12]]);
}

function doChangeLocation(client, _ref4) {
  var lat = _ref4.lat,
      lon = _ref4.lon;

  var _ref5, _ref6, _ref6$, locationData, msaList, msa, newMsaId, path;

  return _regenerator2.default.wrap(function doChangeLocation$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.glsLocation, [client, lat, lon]), (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.msas, [client]), (0, _effects.call)(_location.persistUserLocation, lat, lon)]);

        case 2:
          _ref5 = _context4.sent;
          _ref6 = (0, _slicedToArray3.default)(_ref5, 2);
          _ref6$ = _ref6[0];
          locationData = _ref6$ === undefined ? {} : _ref6$;
          msaList = _ref6[1];
          msa = locationData.msa || {};

          if (!(msa.id && msa.package_purchase)) {
            _context4.next = 12;
            break;
          }

          _context4.t0 = msa.id;
          _context4.next = 15;
          break;

        case 12:
          _context4.next = 14;
          return (0, _effects.call)(_location2.openLocationModal);

        case 14:
          _context4.t0 = _context4.sent;

        case 15:
          newMsaId = _context4.t0;
          _context4.next = 18;
          return (0, _effects.put)((0, _homepage.setMsaId)(newMsaId || null));

        case 18:
          _context4.next = 20;
          return (0, _effects.select)(_request.pathSelector);

        case 20:
          path = _context4.sent;

          if (!path.includes('/pricing/')) {
            _context4.next = 26;
            break;
          }

          _context4.next = 24;
          return (0, _effects.call)(doRedirectPricingPages, client, { path: path, msaList: msaList, newMsaId: newMsaId });

        case 24:
          _context4.next = 28;
          break;

        case 26:
          _context4.next = 28;
          return (0, _effects.call)(doRedirectGenericPages, client, { path: path, msaList: msaList, newMsaId: newMsaId });

        case 28:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function loadSaga(client) {
  return _regenerator2.default.wrap(function loadSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.msas, [client]), (0, _effects.call)(_helpers.getUserLocation, client)]);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function watchSaga(client) {
  return _regenerator2.default.wrap(function watchSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, changeLocation().type, doChangeLocation, client);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}